module.exports = {"450302001":"秀峰街道","450302002":"丽君街道","450302003":"甲山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450302.json
// module id = 1918
// module chunks = 0